import { createSelector } from 'reselect'

import { NetworkContentRootState } from '../networkContentRoot.reducer'

export const getGooglePageFeeds = createSelector(
  (state: NetworkContentRootState) => state.googleMyBusinessStore.googleFeeds,
  (state) => state,
)
